import DescriptionField from './DescriptionField';

export default DescriptionField;
